module.exports = __webpack_public_path__ + "static/media/video-link.18335f3a.png";